import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useLayoutEffect, useEffect } from 'react';
function getMentionNodes(root) {
  if (root) {
    var mentions = root.querySelectorAll("[data-sb-mention='true']");
    var mentionsArray = Array.from(mentions);
    return mentionsArray;
  }
  return [];
}

/**
 * This is a dirty way to get the mentions given DOM node
 */
function useDirtyGetMentions(_ref, _ref2) {
  var ref = _ref.ref;
  var logger = _ref2.logger; // Select the node that will be observed for mutations
  var targetNode = ref.current;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    mentionNodes = _useState2[0],
    setMentionNodes = _useState2[1]; // to get the initial mentions
  useLayoutEffect(function () {
    if (targetNode) {
      var mentions = getMentionNodes(targetNode);
      setMentionNodes(mentions);
    }
  }, [targetNode]);
  useEffect(function () {
    // Options for the observer (which mutations to observe)
    var config = {
      childList: true,
      subtree: true
    };

    // Callback function to execute when mutations are observed
    var callback = function callback(mutationList) {
      var hasMutation = mutationList.length > 0;
      if (hasMutation) {
        setMentionNodes(getMentionNodes(targetNode));
      }
    };

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);
    if (targetNode) {
      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
      logger.info('useDirtyGetMentions: observer started', {
        observer: observer,
        config: config
      });
    }
    return function () {
      try {
        observer.disconnect();
        logger.info('useDirtyGetMentions: observer disconnected', {
          observer: observer
        });
      } catch (error) {
        logger.error('useDirtyGetMentions: observer disconnect failed', {
          observer: observer
        });
      }
    };
  }, [targetNode]);
  return mentionNodes;
}
export { useDirtyGetMentions as u };